import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import {get_leaders, get_simulation_detail_summary} from '../services/api';
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import { motion } from "framer-motion";
import warning_decision from '../assets/warning_decision.png';
import task_indicator_achieved from '../assets/task_indicator_achieved.png';
import task_indicator_notachieved from '../assets/task_indicator_notachieved.png';
import Button from '../../common/Button'
import FcModuleStyle from '../styles/fc.module.css';

const StudentReview = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const [listOfUsers, setListOfUsers] = useState([]);
    const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
    const [selectedSessionid, setSelectedSessionid] = useState(null);
    const [instructorPageHeight, setInstructorPageHeight] = useState("");
    const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError] = useOutletContext();
    const [isLeaderBoard, setIsLeaderBoard] = useState(true);
    const [leaderBoardData, setLeaderBoardData] = useState(null);
    const [currentTab, setCurrentTab] = useState("Review");
    const [userRankingData, setUserRankingData] = useState(null);

    let session_id = queryParams.get("sid");
    let resource_id = queryParams.get("resid");
    let course_id = queryParams.get("cid");

    const checkNum = (num, factor) => {
        return num < 0
           ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
              minimumFractionDigits: factor,
              maximumFractionDigits: factor,
           })}`
           : `$${num?.toLocaleString(undefined, {
              minimumFractionDigits: factor,
              maximumFractionDigits: factor,
           })}`;
     };
    const getSimulationDetailSummary = () => {  
       ((simObj?.sessionid != undefined || session_id != undefined) && selectedSessionid != null) && get_simulation_detail_summary(session_id, selectedSessionid).then(
            (response) => {
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                    setError(response?.data)
                }
                else{
                setSimulationDetailSummary(response?.data);
                setSimObj((prevObj) => ({
                    ...prevObj,
                    simulationdetails: response?.data
                }));
                setIsLoader(false);
                setIsOverlay(false);
            }
            }
        ).catch((error) => {
            // setError("Please complete simulation before reviewing results.");
            setError({"id":"00000","msg":"Please complete simulation before reviewing results."})
            console.log(error);
        })
    };
    const getDate = (date) => {
        let dateObject = new Date(date * 1000);
        let options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
        if (navigator.userAgent.indexOf('iPhone') > -1) {
            dateObject = new Date(date.replace(/-/g, "/"));
        }
        return dateObject.toLocaleString(navigator.language, options);
    }
    const goToSummary = (e) => {
        setIsLoader(true);
        let attempt = window.$(e.target).closest("td").find(`div:first`).attr("attempt");
        queryParams.set("userid", selectedSessionid);
        queryParams.set("attempt", attempt);
        queryParams.set("role", "student");
        ((queryParams.toString().indexOf("&userid=") != -1) && (queryParams.toString().indexOf("&attempt=") != -1)) ? navigate(`${rootRoute}/fc/summary?${queryParams}`) : navigate(`${rootRoute}/fc/summary?${queryParams}&userid=${selectedSessionid}&role=student&attempt=${attempt}`)    
    } 
    const goToDecisionHistory = (e) => {
        setIsLoader(true);
        let attempt = window.$(e.target).closest("td").find(`div:first`).attr("attempt");
        queryParams.set("userid", selectedSessionid);
        queryParams.set("attempt", attempt);
        queryParams.set("role", "student");
        ((queryParams.toString().indexOf("&userid=") != -1) && (queryParams.toString().indexOf("&attempt=") != -1)) ? navigate(`${rootRoute}/fc/decisionhistory?${queryParams}`) : navigate(`${rootRoute}/fc/decisionhistory?${queryParams}&userid=${selectedSessionid}&role=student&attempt=${attempt}`)
    }
    useEffect(() => { setIsLoader(true); getSimulationDetailSummary(); }, [selectedSessionid != null])
    useEffect(() => {
        document.querySelector("header.header").style.display = "none";
        const instructorReviewPageHeight = window.innerHeight - document.getElementsByClassName(`${FcModuleStyle.header}`)[0].clientHeight - document.querySelector(`.footer`).clientHeight;
        setInstructorPageHeight(instructorReviewPageHeight);
        if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
            document.querySelector("footer.footer .footer-nav .footer-links").style.display = "none";
         }
        if (document.querySelector("footer.footer .container") != null) {
            document.querySelector("footer.footer .container").style.justifyContent = "center";
        }
        document.title = "Forecasting | Student Review";
        return () => { 
            if (document.getElementById("instructorreviewContainer") != undefined) {
                document.getElementById("instructorreviewContainer").childNodes[0].style.display = "block";
            }

            if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
                document.querySelector("footer.footer .footer-nav .footer-links").style.display = "block";
            }
             if (document.querySelector("footer.footer .container") != null) {
                document.querySelector("footer.footer .container").style.justifyContent = "space-between";
            }
        };
    }, [simObj?.sessionid])
    useEffect(()=>{
        setSelectedSessionid(session_id);
        document.querySelector(".App .row").style.minHeight = "auto";
        return () => {
            document.querySelector(".App .row").style.minHeight = "100vh";
        }
    },[])
    useEffect(()=>{
        if(currentTab == "LeaderBoard" && !leaderBoardData){
            setIsLoader(true);
            get_leaders(resource_id,course_id).then((response) => {
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                setError(response?.data)
                }
                else {
                if (typeof response != 'undefined') {
                    setIsLoader(false);
                    setLeaderBoardData(response?.data);
                    setUserRankingData(response.data.find((item)=>item.sessionid == session_id))
                }
                }
            }).catch((error) => {
                // setError("Only instructor can change settings.");
                setError({ "id": "00000", "msg": "Only instructor can change settings." })
                console.log(error);
            })
        } 
    },[currentTab])

    useEffect(()=>{
        if(simulationDetailSummary?.length>0){
            setIsLeaderBoard(simulationDetailSummary[0]?.isLeaderBoard ? simulationDetailSummary[0]?.isLeaderBoard : 0);
        }
    },[simulationDetailSummary])

    return (
        <motion.div id="instructorreviewContainer" className={`${FcModuleStyle['instructorreview-container']}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} >
            <header className={`header ${FcModuleStyle.header}`}>
                <div className={`container ${FcModuleStyle.container}`}>
                    <h1>{(isLeaderBoard && currentTab == "LeaderBoard") ? "Forecasting Simulation - Leader Board" : (isLeaderBoard && currentTab == "Ranking") ? "Forecasting Simulation - Ranking" : "Forecasting Simulation - Review"}</h1>
                {
                    (isLeaderBoard && currentTab == "Review") ? <Button btnName={"Leader Board"} clickEventHandler={()=> setCurrentTab("LeaderBoard")}></Button> : ""
                }
                {
                    (isLeaderBoard && currentTab == "LeaderBoard") ? 
                    <div style={{display:"flex"}}><Button btnName={"Ranking"} clickEventHandler={()=> setCurrentTab("Ranking")} customBtnStyle={{"margin-right":"10px"}}></Button><Button btnName={"Review"} clickEventHandler={()=> setCurrentTab("Review")}></Button></div> : ""
                }
                {
                    (isLeaderBoard && currentTab == "Ranking") ? <Button btnName={"Review"} clickEventHandler={()=> setCurrentTab("Review")}></Button> : ""
                }
                </div>
            </header>
            {
                (isLeaderBoard && currentTab == "LeaderBoard") ?
                <div className={`${FcModuleStyle['instructor-table']}`} style={{ height: instructorPageHeight + "px" }}>
                <table className={`ui unstackable table ${FcModuleStyle.ui} ${FcModuleStyle.unstackable} ${FcModuleStyle.table} ${FcModuleStyle['table-container']}`}>
                    <thead>
                        <tr style={{"height":"40px"}}>
                            <th className={`two wide`}></th>
                            <th className={`two wide`}></th>
                            <th className={`two wide`}></th>
                            <th className={`two wide`}></th>
                            <th className={`two wide`}></th>
                            <th className={`two wide`}></th>
                            <th className={`four wide`}></th>
                        </tr>
                    </thead>
                    {/* <tbody>
                    </tbody> */}
                </table>
                <p className={`${FcModuleStyle['user-ranking-msg']}`}>You are in the top {userRankingData?.percent}% of your class, rank {userRankingData?.urank} of {userRankingData?.total}.</p>

                </div>
                :(isLeaderBoard && currentTab == "Ranking") ? 
    
                    <div className={`${FcModuleStyle['instructor-table']}`} style={{ height: instructorPageHeight + "px" }}>
                    <table className={`ui unstackable table ${FcModuleStyle.ui} ${FcModuleStyle.unstackable} ${FcModuleStyle.table} ${FcModuleStyle['table-container']}`}>
                        <thead>
                            <tr style={{"textAlign":"left"}}>
                                <th className={`two wide`}>Rank</th>
                                <th className={`two wide`}><span className={`${FcModuleStyle['text-img-box']}`} style={{display:"inline"}}>Score</span></th>
                                <th className={`three wide`}>Completion Date</th>
                                <th className={`three wide`}>Target MAPE (%)</th>
                                <th className={`three wide`}>Final MAPE (%)</th>
                                <th className={`three wide`}>% Goal Completion</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                leaderBoardData?.map((simDObj, index) => (
                                    <tr key={index} style={(simDObj?.sessionid == session_id) ? {backgroundColor : "rgb(251, 223, 214)",textAlign:'left'} : {textAlign:"left"}}>
                                        <td style={{"paddingLeft": "20px"}}>{simDObj?.urank}{(simDObj?.sessionid == session_id) ? " (You)" : ''}</td>
                                        <td>{simDObj?.score}%</td>
                                        <td>{getDate(simDObj?.completiontime)}</td>
                                        <td style={{"paddingLeft": "15px"}} className={`${FcModuleStyle['amount-value']}`}>Under {simDObj?.targetprofit}%</td>
                                        <td style={{"paddingLeft": "15px"}}  className={`${FcModuleStyle['amount-value']}`}>{simDObj?.hprofit}%</td>
                                        {/* <td><img className={simDObj?.targetcompleted ? 'target_achieved' : 'target_notachieved'} src={simDObj?.targetcompleted ? task_indicator_achieved : task_indicator_notachieved} /></td> */}
                                        <td style={{"paddingLeft": "20px"}}>{simDObj?.percom}%</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    </div> 
                    :
                    <div className={`${FcModuleStyle['instructor-table']}`} style={{ height: instructorPageHeight + "px" }}>
                        <table className={`ui unstackable table ${FcModuleStyle.ui} ${FcModuleStyle.unstackable} ${FcModuleStyle.table} ${FcModuleStyle['table-container']}`}>
                            <thead>
                                <tr>
                                    <th className={`one wide`}>Attempt #</th>
                                    <th className={`two wide`}>Start Date</th>
                                    <th className={`two wide`}>Completion Date</th>
                                    <th className={`two wide`}>Time Spent (Minutes)</th>
                                    <th className={`two wide`}>MAPE (%)</th>
                                    <th className={`one wide`}>Target Achieved</th>
                                    <th className={`two wide`}><span className={`${FcModuleStyle['text-img-box']}`} data-tooltip="Your best score will be reported to the gradebook" data-position="bottom left">Score<img src={warning_decision} /></span></th>
                                    <th className={`four wide`}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    simulationDetailSummary?.map((simDObj, index) => (
                                        <tr key={index}>
                                            <td>{simDObj?.attemptno}</td>
                                            <td>{getDate(simDObj?.creationtime)}</td>
                                            <td>{getDate(simDObj?.completiontime)}</td>
                                            <td>{`${Math.max(1, Math.floor((simDObj.completiontime - simDObj.creationtime) / 60).toLocaleString())}`}</td>
                                            <td className={`${FcModuleStyle['amount-value']}`}>{simDObj?.overAllMAPE}</td>
                                            <td><img className={simDObj?.targetcompleted ? 'target_achieved' : 'target_notachieved'} src={simDObj?.targetcompleted ? task_indicator_achieved : task_indicator_notachieved} /></td>
                                            <td>{simDObj?.score}%</td>
                                            <td>
                                                <div className={`${FcModuleStyle['button-wrapper']}`} attempt={simDObj?.attemptno}>
                                                    <Button btnClass={"ui button summary"} clickEventHandler={goToSummary} btnName={"Summary"} />
                                                    <Button btnClass={"ui button decision-history"} clickEventHandler={goToDecisionHistory} btnName={"Decision History"} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
            }
        </motion.div>
    );
}

export default StudentReview